'use client';

import { Spinner as ChakraSpinner, SpinnerProps as ChakraSpinnerProps, defineStyleConfig } from '@chakra-ui/react';

export const spinnerTheme = defineStyleConfig({
  baseStyle: {
    borderWidth: 3,
    borderBottomColor: 'border/primary',
    borderLeftColor: 'border/primary',
    borderRightColor: 'border/primary'
  },
  sizes: {
    small: {
      width: '20px',
      height: '20px'
    },
    medium: {
      width: '50px',
      height: '50px'
    },
    large: {
      width: '100px',
      height: '100px'
    }
  },
  variants: {
    normal: {
      color: 'icon/hover'
    },
    success: {
      color: 'status/success/default'
    },
    danger: {
      color: 'status/error/default'
    },
    isLoading: {
      color: 'currentColor',
      borderBottomColor: 'currentColor',
      borderRightColor: 'currentColor',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent',
      borderWidth: 2
    }
  }
});

interface SpinnerProps extends ChakraSpinnerProps {
  variant: 'normal' | 'success' | 'danger' | 'isLoading';
  size: 'small' | 'medium' | 'large';
}

const Spinner = ({ variant, size, ...rest }: SpinnerProps) => {
  return <ChakraSpinner variant={variant} size={size} {...rest} />;
};

export default Spinner;
